"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var adobeUtils = _interopRequireWildcard(require("../utils/adobe"));

var _sendEvent = require("../events/sendEvent");

var _eventGate = _interopRequireDefault(require("../events/eventGate"));

var _legacyEvent = _interopRequireDefault(require("../events/legacyEvent"));

var _structureData = _interopRequireDefault(require("./structureData"));

var _stateManager = _interopRequireDefault(require("./stateManager"));

var _batcher = _interopRequireDefault(require("./batcher"));

var _constants = require("../constants");

var _misc = require("../utils/misc");

var _getEnvironmentContext = require("../utils/getEnvironmentContext");

var _errorEmitter = require("../utils/errorEmitter");

var _logger = _interopRequireDefault(require("../utils/logger"));

var _eventContentCache = _interopRequireDefault(require("./eventContentCache"));

var _viewPreviousCache = _interopRequireDefault(require("./viewPreviousCache"));

// Send error upon duplicate init:
var Client = /*#__PURE__*/function () {
  function Client() {
    var _this = this;

    (0, _classCallCheck2["default"])(this, Client);
    (0, _defineProperty2["default"])(this, "_eventCache", void 0);
    (0, _defineProperty2["default"])(this, "_runningTimeout", void 0);
    (0, _defineProperty2["default"])(this, "_countdownPromise", void 0);
    (0, _defineProperty2["default"])(this, "_readAndEmptyCache", void 0);
    (0, _defineProperty2["default"])(this, "stateManager", void 0);
    (0, _defineProperty2["default"])(this, "batcher", void 0);
    (0, _defineProperty2["default"])(this, "isInit", void 0);
    (0, _defineProperty2["default"])(this, "endpoint", void 0);
    (0, _defineProperty2["default"])(this, "eventGate", void 0);
    (0, _defineProperty2["default"])(this, "batchInterval", void 0);
    (0, _defineProperty2["default"])(this, "eventContentCache", void 0);
    (0, _defineProperty2["default"])(this, "viewPreviousCache", void 0);
    (0, _defineProperty2["default"])(this, "cachedViewPrevious", void 0);
    (0, _defineProperty2["default"])(this, "_sendDoubleInitError", function (sessionData) {
      var stateComparison = JSON.stringify({
        originalState: _this.stateManager.get(),
        newState: sessionData
      });
      var msg = "init is called twice: ".concat(stateComparison);

      _logger["default"].error(new Error(msg));
    });
    (0, _defineProperty2["default"])(this, "getAdobeData", adobeUtils.getAdobeData);
    (0, _defineProperty2["default"])(this, "structureData", function (eventSpecs) {
      return (0, _structureData["default"])(_this, eventSpecs);
    });
    (0, _defineProperty2["default"])(this, "updateState", function (stateChunk) {
      return _this.stateManager.update(stateChunk);
    });
    (0, _defineProperty2["default"])(this, "init", function (sessionData) {
      // Extract only what's needed, and default as needed:
      var endpoint = sessionData.endpoint,
          batchIntervalInput = sessionData.batchInterval,
          useLocalPort = sessionData.useLocalPort,
          errorHandler = sessionData.errorHandler,
          analyticsAgent = sessionData.analyticsAgent,
          appId = sessionData.appId,
          appVer = sessionData.appVer,
          authState = sessionData.authState,
          cheggUuid = sessionData.cheggUuid,
          clientExperiments = sessionData.clientExperiments,
          experiments = sessionData.experiments,
          clientIpAddress = sessionData.clientIpAddress,
          referralUrl = sessionData.referralUrl,
          _sessionData$testCell = sessionData.testCells,
          testCells = _sessionData$testCell === void 0 ? [] : _sessionData$testCell,
          url = sessionData.url,
          subscriptions = sessionData.subscriptions,
          uvn = sessionData.uvn,
          view = sessionData.view,
          dfid = sessionData.dfid,
          userAgentInput = sessionData.userAgent,
          property = sessionData.property,
          alternateUserId = sessionData.alternateUserId,
          alternateUserIdLabel = sessionData.alternateUserIdLabel;

      if (_this.isInit) {
        _this._sendDoubleInitError(sessionData);

        _this.reset();
      } // Set error handling behavior:


      (0, _errorEmitter.init)(errorHandler); // Begin the adobe user data acquisition. It won't be needed till the first
      // event is sent, so the `await` can wait till then.

      adobeUtils.init()["catch"](_logger["default"].error); // Set endpoint based on config or environment:

      var localPort = useLocalPort ? (0, _misc.getLocalPortFromParam)(useLocalPort) : (0, _misc.getLocalPortFromUrl)();
      _this.endpoint = localPort ? "http://localhost:".concat(localPort) : endpoint;
      _this.batchInterval = batchIntervalInput || _constants.DEFAULT_BATCH_INTERVAL;
      var rswVersion = "9.6.44"; // Derive user agent from session data or window scope.

      var userAgent = (0, _misc.getUserAgent)(userAgentInput); // Get browser data to include with requests:

      var _getEnvironmentContex = (0, _getEnvironmentContext.get)(userAgent),
          browserName = _getEnvironmentContex.browserName,
          browserVersion = _getEnvironmentContex.browserVersion,
          osName = _getEnvironmentContex.osName,
          osVersion = _getEnvironmentContex.osVersion,
          platform = _getEnvironmentContex.platform;

      var initialState = {
        appId: appId,
        analyticsAgent: analyticsAgent,
        userAgent: userAgent,
        url: url,
        referralUrl: referralUrl,
        rswVersion: rswVersion,
        browserName: browserName,
        browserVersion: browserVersion,
        authState: authState,
        cheggUuid: cheggUuid,
        clientIpAddress: clientIpAddress,
        testCells: testCells,
        osName: osName,
        osVersion: osVersion,
        platform: platform,
        property: property,
        appVer: appVer,
        clientExperiments: clientExperiments,
        experiments: experiments,
        uvn: uvn,
        view: view,
        dfid: dfid,
        subscriptions: subscriptions,
        alternateUserId: alternateUserId,
        viewPrevious: _this.cachedViewPrevious,
        alternateUserIdLabel: alternateUserIdLabel
      }; // Pass session data to state:

      _this.stateManager.init(initialState); // Signal to the app that init has taken place:


      _this.eventGate.allowSends();

      _this.eventGate.queuePreloadEvents(); // Relay all events that accumulated before client was init:


      _this.batcher.startCountdown();

      _this.isInit = true;
    });
    (0, _defineProperty2["default"])(this, "reset", function () {
      _this.stateManager.reset();

      _this.eventGate.blockSends();

      _this.isInit = false;
    });
    (0, _defineProperty2["default"])(this, "sendEvent", function (params) {
      return (0, _sendEvent.sendEvent)(_this, params);
    });
    (0, _defineProperty2["default"])(this, "event", function (eventSpecs, options) {
      return (0, _legacyEvent["default"])(_this, eventSpecs, options);
    });
    (0, _defineProperty2["default"])(this, "_nakedEvent", function (eventSpecs, options) {
      return (0, _sendEvent.nakedEvent)(_this, eventSpecs, options);
    });
    (0, _defineProperty2["default"])(this, "writeEventContentCache", function (newData) {
      _this.eventContentCache.write(newData);
    });
    (0, _defineProperty2["default"])(this, "readEventContentCache", function () {
      return _this.eventContentCache.read();
    });
    (0, _defineProperty2["default"])(this, "clearEventContentCache", function () {
      _this.eventContentCache.clear();
    });
    this.viewPreviousCache = new _viewPreviousCache["default"]();
    this.cachedViewPrevious = this.viewPreviousCache.get();
    this.stateManager = new _stateManager["default"](this);
    this.eventContentCache = new _eventContentCache["default"]();
    this.batcher = new _batcher["default"](this);
    this.eventGate = new _eventGate["default"](this);

    if (!(0, _misc.noWindow)()) {
      this._startInitTimer();
    }
  }

  (0, _createClass2["default"])(Client, [{
    key: "_startInitTimer",
    value: function _startInitTimer() {
      var _this2 = this;

      setTimeout(function () {
        if (!_this2.isInit) {
          _logger["default"].warn('Init was not called on client within 7000ms of being created');
        }
      }, _constants.INIT_TIMEOUT_THRESHOLD);
    }
  }]);
  return Client;
}();

var _default = Client;
exports["default"] = _default;